import { useState, useEffect } from "react";
import { getLastCheckout } from "../api";
import TimePicker from "./TimePicker";
import logo from "../assets/logo.png";

export default function LoginScreen({ pinInput, pinError, pinMessage, onPress, onDelete, onLogin }) {
  const [step, setStep] = useState("pin");
  const [employee, setEmployee] = useState(null);
  const [hour, setHour] = useState(10);
  const [minute, setMinute] = useState(0);
  const [minHour, setMinHour] = useState(10);
  const [minMinute, setMinMinute] = useState(0);

  useEffect(() => {
    getLastCheckout().then(r => {
      if (r && r.lastEndTime) {
        const cleaned = r.lastEndTime.replace("h",":");
        const parts = cleaned.split(":");
        if (parts.length === 2) {
          const h = parseInt(parts[0]);
          const m = parseInt(parts[1]);
          if (h >= 10 && h <= 20) { setHour(h); setMinute(m === 30 ? 30 : 0); setMinHour(h); setMinMinute(m === 30 ? 30 : 0); }
        }
      }
    }).catch(() => {});
  }, [step]);

  const dots = [0,1,2,3].map(i => ({ filled: i < pinInput.length }));

  if (step === "time") return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"100vh", padding:"40px 24px", gap:40 }} className="fade-in">
      <div style={{ textAlign:"center" }}>
        <img src={logo} alt="XBENT" style={{ width:140, mixBlendMode:"screen" }} />
        <div style={{ color:employee?.color, fontSize:22, fontWeight:700, marginTop:12 }}>{employee?.name}</div>
        <div style={{ color:"#444", fontSize:12, marginTop:4, letterSpacing:3 }}>WANN FÄNGST DU AN?</div>
      </div>
      <TimePicker hour={hour} minute={minute} onHourChange={setHour} onMinuteChange={setMinute} minHour={minHour} minMinute={minMinute} />
      <div style={{ color:"#333", fontSize:11, letterSpacing:2 }}>10:00 – 20:00</div>
      <button onClick={() => onLogin(employee, `${String(hour).padStart(2,"0")}:${String(minute).padStart(2,"0")}`)}
        style={{ width:"100%", padding:"20px", borderRadius:18, border:"none", background:"linear-gradient(135deg,#00E5FF,#00B8CC)", color:"#000", fontSize:18, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 20px #00E5FF30" }}>
        ✓ Schicht starten
      </button>
    </div>
  );

  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"100vh", padding:"40px 24px", gap:44 }} className="fade-in">
      <div style={{ textAlign:"center" }}>
        <img src={logo} alt="XBENT" style={{ width:200, mixBlendMode:"screen" }} />
        <div style={{ color:"#333", fontSize:11, marginTop:8, letterSpacing:3 }}>KASSENSYSTEM</div>
      </div>
      <div style={{ display:"flex", gap:18 }} className={pinError ? "shake" : ""}>
        {dots.map((d,i) => (
          <div key={i} style={{ width:14, height:14, borderRadius:"50%", background:pinError?"#EF4444":d.filled?"#00E5FF":"transparent", border:`2px solid ${pinError?"#EF4444":d.filled?"#00E5FF":"#333"}`, transition:"all .15s", boxShadow:d.filled&&!pinError?"0 0 8px #00E5FF60":"none" }} />
        ))}
      </div>
      {pinMessage && (
        <div style={{ background:"#EF444415", border:"1px solid #EF444440", borderRadius:12, padding:"12px 20px", textAlign:"center", color:"#EF4444", fontSize:14, fontWeight:600 }}>
          {pinMessage}
        </div>
      )}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,76px)", gap:14 }}>
        {[1,2,3,4,5,6,7,8,9,"",0,"⌫"].map((k,i) => {
          if (k==="") return <div key={i}/>;
          const isDel = k==="⌫";
          return (
            <button key={i} onClick={() => isDel ? onDelete() : onPress(String(k), emp => { setEmployee(emp); setStep("time"); })}
              style={{ width:76, height:76, borderRadius:22, background:isDel?"#141414":"#161616", border:`1.5px solid ${isDel?"#1E1E1E":"#222"}`, color:isDel?"#555":"#EEE", fontSize:isDel?20:26, fontFamily:"'Space Mono',monospace", fontWeight:700, cursor:"pointer", transition:"all .08s", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 0 #0D0D0D" }}
              onPointerDown={e=>{e.currentTarget.style.transform="scale(0.93)";e.currentTarget.style.background="#00E5FF20"}}
              onPointerUp={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.background=isDel?"#141414":"#161616"}}
            >{k}</button>
          );
        })}
      </div>
      <div style={{ color:"#2A2A2A", fontSize:11, letterSpacing:2 }}>MITARBEITER PIN EINGEBEN</div>
    </div>
  );
}
